{
  "Login": {
    "Title": "Login to Save your receipt",
    "KakaoButton": "Continue with Kakao",
    "NaverButton": "Continue with Naver",
    "LineButton": "Log in with LINE",
    "GoogleButton": "Continue with Google",
    "FacebookButton": "Continue with Facebook",
    "OR": "OR",
    "MobileNumber": "Mobile Number",
    "Continue": "Continue with Phone Number",
    "EndUserLicenseAgreement": "End-User License Agreement",
    "PrivacyPolicy": "Privacy Policy.",
    "EulaAndPrivacyPolicyTerm": "By continuing, you agree to our \n{eula} and {privacyPolicy}",
    "OtherLoginMethods": "Other Login Methods",
    "SelectCountry": "Please select your country or location",
    "EncourageSocialLogin": "For a faster and more secure experience, \n{signInText}",
    "EncourageSocialLogin2": "sign in via Social Login"
  },
  "BottomNavbar": {
    "Receipts": "Receipts",
    "Account": "Account"
  },
  "PhoneVerification": {
    "Title": "Phone verification",
    "EnterCode": "Enter code",
    "SMSDiscription": "We have sent an SMS with a code to your phone",
    "InvalidOtp": "Invalid Code",
    "TryAgainInfo": "Please try again.",
    "OTPExpireTime": "The OTP code will expire in ",
    "OTPNotArrive": "Haven't receive the code?",
    "Resend": "Resend OTP",
    "ChangePhone": "Change Phone Number",
    "ResendToast": "We've sent a new 6-digit OTP code to your phone."
  },
  "ReceiptLoader": {
    "PleaseWait": "Please wait...",
    "TakingLongerText": "Your receipt seems to be taking longer than expected...",
    "NotifyText2": "We’ll notify you when receipt is ready",
    "OKButton": "OK",
    "LoginButton": "LOGIN",
    "NotifyMeButton": "Notify Me",
    "ReceiptWait": "Your receipt should appear here shortly",
    "VoidReceiptTitle": "This Receipt is voided",
    "VoidReceiptSubtitle": "Please contact the merchant for more information.",
    "SharedReceiptText": "Please login to view shared receipt.",
    "InvalidHashText": "Unable to load receipt now. Receipt URL is not correct."
  },
  "SaveReceipt": {
    "Description": "Your receipt is currently not saved!\nTap below to save it now.",
    "SaveReceipt": "Save Receipt",
    "SaveInfo": "Receipt saved to Cloud.",
    "UpdatedGoogleWallet": "Saved to Google Wallet",
    "UpdatedSamsungWallet": "Receipt added to Samsung Wallet"
  },
  "PushNotification": {
    "NewReceipt": "Access new receipts easily with\npush notification.",
    "Notification": "Notification",
    "AllowNotification": "Allow notification for Piperks?",
    "Deny": "Deny",
    "Allow": "Allow",
    "NotificationInfo": "We'll notify you when receipts arrive"
  },
  "WhatsAppPrompt": {
    "Title": "We are here to help",
    "SubTitle": "Select your topic:",
    "IssueWithPurchase": "Issues with my purchase",
    "Feedback": "General Feedback",
    "ReceiptError": "Error with Receipt",
    "AccountIssue": "Account Issues",
    "ReceiptNumber": "My receipt number is {receiptNo}",
    "IssuePurchaseText": "I’m having issues with my purchase. ",
    "FeedbackText": "I’m having general feedback for you. ",
    "ReceiptErrorText": "I’m having issues with my receipt. ",
    "AccountIssueText": "I’m having issues with my account. "
  },
  "PWAPrompt": {
    "Description": "Access receipts offline with\none tap install.",
    "Install": "INSTALL"
  },
  "AppUpdatePrompt": {
    "Description": "A newer version of Piperks is available. Please refresh the page or press the button to update it to the newest version.",
    "Title": "Update Available",
    "Button": "UPDATE"
  },
  "MyReceipts": {
    "Title": "My Receipts",
    "ReceiptLoadingText": "Loading...",
    "EmptyInfo": "It’ll look less empty when your receipts\nare added here!",
    "EmptyFilter": "Change your filter settings to show more receipts here",
    "EndOfReceipts": "All receipts have been displayed"
  },
  "SalesReceipt": {
    "HelpText": "Need help?",
    "WhatsAppButton": "Message us on WhatsApp",
    "FollowUs": "Follow Us On:"
  },
  "ReceiptExport": {
    "ExportingReceiptText": "Exporting Receipt.",
    "ReceiptExportSuccessText": "Receipt in Downloads."
  },
  "Settings": {
    "ProfileCompleteText": "Complete your Profile",
    "AccountInformation": "Account Information",
    "EnterDetailsText": "Enter your details for easier account recovery",
    "Name": "Name",
    "Edit": "Edit",
    "Male": "Male",
    "Phone": "Phone",
    "Gender": "Gender",
    "Dob": "Date of Birth",
    "Email": "Email",
    "HomeAddress": "Home Address",
    "Female": "Female",
    "Other": "Other",
    "Indonesia": "Indonesia",
    "Malaysia": "Malaysia",
    "Singapore": "Singapore",
    "SouthKorea": "South Korea",
    "Japan": "Japan",
    "SetNow": "Set Now",
    "LocationAndLanguage": "Location & Language",
    "DisplayLanguage": "Select your preferred display language",
    "Country": "Country",
    "Language": "Language",
    "LocationAccessTitle": "Location Access",
    "LocationAccessDescription": "Allow to set your language automatically.",
    "Notification": "Notification",
    "PushNotification": "Push Notification",
    "GetUpdates": "Get important updates to you",
    "ReceiptAlerts": "Receipt Alerts",
    "NotifiedLatestReceiptsAndUpdates": "Be notified of your latest receipts and updates.",
    "LinkedAccounts": "Linked Accounts",
    "EnableLogins": "Enable for faster logins",
    "PwaInstallButton": "Install Piperks App",
    "ContactSupportButton": "Contact Support",
    "LogoutButton": "Logout",
    "Version": "Version",
    "SupportViaEmail": "Support via Email",
    "SupportViaWhatsApp": "Support via WhatsApp"
  },
  "Modal": {
    "PushNotif": {
      "Title": "Push notification blocked ?",
      "Message1": "Please follow the steps below to enable Push Notification manually.",
      "Message2": "1. Click on the information icon to the left of the URL.",
      "Message3": "2. Next to “Notifications”, select either “Ask” or “Allow”.",
      "Message4": "3. Reload the page to apply the updated settings."
    },
    "BaseCountry": {
      "Title": "Country",
      "Message1": "The country listed on your account page is where your data is kept.",
      "Message2": "Your data is currently saved in '{0}'",
      "Message3": "If you would like to change the location of where your data is kept,",
      "Action1": "Click Here"
    }
  },
  "Message": {
    "Subject": "Support needed for Piperks App",
    "TypeMessage": "Type your message here:",
    "HelpTroubleshoot": "[DO NOT DELETE THIS SECTION TO HELP TROUBLESHOOTING]",
    "PhoneModel": "Phone Model: ",
    "PhoneOS": "Phone OS Version: ",
    "BrowserVersion": "Browser Version: ",
    "RegisteredID": "Registered Id: ",
    "LatestReceipt": "Latest Receipt: "
  },
  "ReceiptDetail": {
    "Store": "Store: ",
    "POS": "POS: ",
    "Cashier": "Cashier: ",
    "TotalSpend": "TOTAL SPEND",
    "PreSettlementTotalSpend": "PROCESSING PAYMENT",
    "YouSave": "YOU SAVED",
    "TotalPaid": "TOTAL PAID",
    "Change": "CHANGE",
    "Tax": "TAX: ",
    "Items": "ITEMS",
    "ItemReturned": "# ITEMS RETURNED ",
    "ItemSold": "# ITEMS SOLD",
    "WifiPassword": "Copy Wifi Password",
    "FreeWifi": "FREE WIFI",
    "PreSettlementTotal": "NOT YOUR FINAL RECEIPT.\n\nFINAL RECEIPT WILL APPEAR ONCE PAYMENT IS\nSUCCESSFUL\n\n"
  },
  "Receipt": {
    "Today": "Today",
    "Yesterday": "Yesterday",
    "VoidReceiptOverlay": "VOID RECEIPT"
  },
  "DataPrompt": {
    "Title": "Account Verification",
    "Body": "Verify your information to secure your receipts for future account validation or recovery",
    "Gender": "Gender",
    "YOB": "Year of Birth",
    "Submit": "Submit",
    "Later": "Later",
    "Select": "Select",
    "DrawerTitle": "Secure your receipts by verifying your recovery details",
    "DrawerBody": "Verify Details"
  },
  "Eula": {
    "Title": "User Agreement"
  },
  "SortFilter": {
    "Title": "Sort and Filter",
    "SortBy": "Sort by",
    "DateAsc": "Date (Old - New)",
    "DateDesc": "Date (New - Old)",
    "TransactionAsc": "Transaction (Low - High)",
    "TransactionDesc": "Transaction (High - Low)",
    "DateRange": "Date Range",
    "Store": "Store",
    "SeeMore": "See More",
    "ShowLess": "Show Less",
    "Apply": "Apply",
    "Reset": "Reset",
    "LastWeek": "Last Week",
    "LastMonth": "Last Month"
  },
  "KoreanExplicit": {
    "Title": "Please agree to use Piperks service",
    "AcceptAll": "Accept All",
    "Required": "Required",
    "TermOfUse": "Terms of Use ",
    "PrivacyPolicy": "Privacy Policy",
    "AgeConsent": "I am 14 years old or older",
    "Continue": "Continue",
    "ViewMore": "view more"
  },
  "ReceiptSharing": {
    "Title": "Receipt Sharing",
    "SubTitle": "Share Link to Anyone",
    "Body": "Receipt sharing feature allows you to share a receipt with others by making it publicly available. When activated, this feature generates a unique receipt sharing link. Anyone who receives this link can use it to view the shared receipt. It's a convenient way to easily share your purchase details or expenses with friends, family, or colleagues.",
    "Irreversible": "irreversible",
    "Invalid": "invalid",
    "ShareLinkExpiry": "Link Expiry Time",
    "Generate": "Generate New Link",
    "GenerateShare": "Generate New Share Link",
    "GenerateBody": "Note: This action is {0}; the previous link will become {1}.",
    "GeneratePrompt": "Click below to generate a new share link.",
    "ShareLink": "Share Receipt Link"
  },
  "EWallet": {
    "PaymentTo": "Payment to",
    "MakePayment": "Make Payment",
    "PaymentProgress": "Payment is in Progress",
    "WaitingPayment": "Please wait a few seconds for processing your payment ...",
    "PaymentCompleted": "Payment Completed!",
    "To": "To"
  },
  "Error": {
    "UnexpectedError": {
      "Title": "Unexpected Error",
      "Body": "Sorry, Something went wrong. Click the button below to try again"
    },
    "TryAgain": "Please retry again shortly.",
    "BtnTextOK": "OK",
    "BtnTextRetry": "Retry",
    "OtpSendingFailed": {
      "Title": "Failed to send OTP",
      "Body": "Please try again after a few minutes"
    },
    "InvalidPhoneNumber": {
      "Title": "Invalid Phone Number",
      "Body": "The phone number you provided is not in the correct format. Please enter your phone number without a country code."
    },
    "IncorrectOtp": {
      "Title": "Incorrect OTP",
      "Body": "Please verify the OTP sent to your registered phone number"
    },
    "SocialLoginFailed": {
      "Title": "{ provider } Login Failed",
      "Body": "Kindly wait a few minutes before retrying"
    },
    "LoginUnsuccessful": {
      "Title": "Login Unsuccessful",
      "Body": "Apologies, an error occurred during your login. Please try again later"
    },
    "UserReceiptsQueryFails": {
      "Title": "Receipt Loading Error",
      "Body": "We're sorry, there was an issue retrieving your receipt. Please try again shortly"
    },
    "GetReceiptError": {
      "Title": "Receipt Retrieval Error",
      "Body": "An unexpected error occurred while fetching your receipt. Please try again shortly"
    },
    "GetReceiptTemplateError": {
      "Title": "Template Retrieval Failed",
      "Body": "An error occurred while fetching the receipt template. Please try again shortly"
    },
    "LinkedToAnotherAccountError": {
      "Title": "Receipt Already Linked",
      "Body": "This receipt is already linked to another account. Reach out to the cashier for more information"
    },
    "LinkReceiptError": {
      "Title": "Receipt Linking Error",
      "Body": "Apologies, we were unable to link the receipt to your account. Please try again soon"
    },
    "ReceiptSubscriptionError": {
      "Title": "Failed to retrieve real-time receipts"
    },
    "AccountUpdateFailed": {
      "Title": "Account Update Failed",
      "Body": "We're sorry, an error occurred while updating your account. Please try again shortly"
    },
    "AccountRetrievalFailed": {
      "Title": "Account Retrieval Failed",
      "Body": "We're sorry, an error occurred while fetching your account data"
    },
    "ServerUnavailable": {
      "Title": "Server Unavailable",
      "Body": "We're currently resolving the issue. Please try again in a few minutes"
    },
    "MissingQueryParam": {
      "Title": "Incomplete Receipt Link",
      "Body": "Looks like something is missing on your receipt link. Please double-check and try again"
    },
    "InvalidReceiptToken": {
      "Title": "Invalid Receipt Link",
      "Body": "Receipt link is already invalid. Reach out to the cashier for more information."
    },
    "ExpiredReceiptLink": {
      "Title": "Receipt Link Expired",
      "Body": "Receipt link has already expired, please save receipt earlier next time"
    },
    "ExpiredShareReceipt": {
      "Title": "Share Link Has Expired",
      "Body": "The shared receipt link has expired. Please ask the sender for a new link or check the shared receipt’s link."
    },
    "InvalidShareReceipt": {
      "Title": "Share Link Not Available",
      "Body": "The shared receipt link is not available. Please ask the sender for a new link or check the shared receipt’s link."
    }
  },
  "OfflineRenderer": {
    "Title": "Receipt",
    "Text": "No Network, Offline Receipt Displayed",
    "Subtext": "Full receipt details will appear when online",
    "StoreNo": "Store No:",
    "ReceiptNo": "Receipt No:",
    "TotalAmount": "Total Amount",
    "PaymentMethod": "Payment Method"
  }
}
